//export const baseURL = 'https://api.snapdragonconquest.com/';
export const baseURL = 'https://api.tmp.tesseractesports.com/';

import Toast from './toast';
import { saveAs } from 'file-saver';
import moment from 'moment';
import CONFIG from './config';
export class RESTClient{
    async get(url){
        let result = await fetch(baseURL+url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                project: CONFIG.PROJECT,
                ...this.auth()
            }
        })
        if(result.headers.get('content-type').indexOf('application/json') == 0){
            result = await result.json();
            if(!result.error) {
                return result;
            }else if(url != 'teams/my' && url != 'users/me'){
                Toast.error(result.message);
                return false;
            }else{
                window.localStorage.removeItem('token');
            }
        }else{
            result = await result.blob();
            //saveAs(result, moment().format('YYYY-MM-DD-HH-mm')+'.xlsx');
            return true;
        }
    }

    async post(url, data, rawBody=false, put=false){
        let options = {
            method: put ? 'PUT' : 'POST',
            headers: {
                project: CONFIG.PROJECT,
                ...this.auth()
            },
            body: rawBody ? data : JSON.stringify(data)
        }
        if(!rawBody){
            options.headers['Content-Type'] =  'application/json';
        }
        let result = await fetch(baseURL+url, options)
        let status = result.status;
        result = await result.json();
        if(status == 200) {
            return result;
        }else{
            if(Array.isArray(result.errors))
                return result;
            else{
                Toast.error(result.message);
                return false;
            }
        }
    }

    async put(url, data, rawBody=false){
        return await this.post(url, data, rawBody, true);
    }

    async delete(url){
        let result = await fetch(baseURL+url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                PROJECT: CONFIG.PROJECT,
                ...this.auth()
            }
        })
        result = await result.json();
        if(!result.error) {
            return result;
        }else{
            if(Array.isArray(result.error))
            return result;
            else
            Toast.error(result.error);
        }
    }

    auth(){
        if(window.localStorage.getItem('token')){
            return {
                'Authorization': 'Bearer '+window.localStorage.getItem('token')
            }
        }else if(this.authData){
            return {
                'Authorization': 'Bearer '+this.authData.token
            }
        }else
        return {};
    }
}